import { GenericAction, GenericActionWithPayload } from "./action-types";

type Error = {
  message: string;
  errors: string[];
};

type APIError = {
  errors?: string[];
  error?: string;
};

interface ErrorResponse {
  response?: {
    data?: {
      error?: string;
      errors?: string[];
      message?: string;
    };
    status: number;
  };
  status?: number;
  error?: string;
}

type ErrorAction =
  | GenericActionWithPayload<"ERROR_SAVE", Error>
  | GenericAction<"CLEAR_ERROR">;

interface PrinterError {
  type: string;
  title: string;
  status: number;
  errors: {
    [key: string]: string[];
  };
  traceId: string;
}

interface PrinterErrorResponse {
  error: PrinterError;
}

export type {
  Error,
  APIError,
  ErrorResponse,
  ErrorAction,
  PrinterError,
  PrinterErrorResponse,
};
